import Grid from "@/components-library/layout/grid";

import PropTypes from "prop-types";
import classes from "./grid-list.module.scss";

function GridList({ columns, items, itemComponent, className }) {
  let columnsProperty = "1fr 1fr 1fr";
  if (typeof window !== "undefined" && window.innerWidth <= 768) {
    columnsProperty = "1fr";
  } else if (columns === 4) {
    columnsProperty = "1fr 1fr 1fr 1fr";
  }
  return (
    <Grid
      columns={columnsProperty}
      style={{ margin: "auto" }}
      className={className}
    >
      {items.map((item, index) => {
        return (
          <itemComponent.type
            key={index}
            item={items[index]}
            {...itemComponent.props}
            className={classes.item}
          />
        );
      })}
    </Grid>
  );
}

GridList.propTypes = {
  items: PropTypes.array.isRequired,
  itemComponent: PropTypes.node.isRequired,
  columns: PropTypes.number,
};

GridList.defaultProps = {
  columns: 3,
};

export default GridList;
